import { IStrategy } from '@navix/utils/adapter'
import { User } from '../domain/user.model'
import { GetTenantUsersRestResponse } from '../domain/get-tenant-users.response'

export class FromGetTenantUsersResponse
  implements IStrategy<GetTenantUsersRestResponse, User[]>
{
  convert = ({ records }: GetTenantUsersRestResponse) =>
    records.map(
      tenantUser =>
        ({
          id: tenantUser.uuid,
          firstName: tenantUser.firstName ?? '',
          lastName: tenantUser.lastName ?? '',
          isActive: tenantUser.isActive ?? true,
          email: tenantUser.email,
          phoneNumber: tenantUser.phoneNumber ?? undefined,
          timezone: tenantUser.timezoneShort ?? undefined,
          createdDate: tenantUser.createdDate
            ? new Date(tenantUser.createdDate)
            : undefined,
          fullName:
            `${tenantUser.firstName ?? ''} ${tenantUser.lastName ?? ''}`.trim(),
          avatarLetter:
            (tenantUser.firstName ?? tenantUser.email)?.[0]?.toUpperCase() ??
            '',
          rolesName:
            Array.isArray(tenantUser.roles) && tenantUser.roles.length
              ? [
                  tenantUser.roles.sort()[0].name,
                  tenantUser.roles
                    .sort()
                    .slice(1)
                    .map(role => role.name)
                    .join(', ')
                ]
              : ['', ''],
          withDetails: false
        }) as User
    )
}
